<template lang="pug">
  .service-category-show
    .category-info(v-if='category')
      .service-category-title(v-text='category.attributes.name')
      .service-category-description.booking-service-description(v-html='category.attributes.description')
    .services
        .service.row(v-for='service in services', :id='service.attributes["slug-url"]')
          .col-lg-5
            img.services-image(:src='service.attributes.image')
          .col-lg-7
            .service-category-title(v-text='service.attributes.name')
            loyalty-tiers(:loyaltyTier='service.attributes["loyalty-tier"]')
            .service-description.booking-service-description(v-html='service.attributes.description')
            div
              span(v-if='service.attributes["terms-and-conditions"] && showTnc()' v-text='`${$t("common.termsAndConditions")}:`')
            .service-description.booking-service-description(v-html='service.attributes["terms-and-conditions"]')
            div(v-if="shouldShowInitialBookNowButton(service) && !buttonStates[service.id].displayTimetrade && !buttonStates[service.id].displayInhouse && service.attributes['bookable'] == true")
              button(
                @click="toggleBookingOptions(service.id)"
                class="btn btn-secondary"
                style="margin-bottom: 10px; width: 200px"
              )
                | {{ $t('retailStore.bookNow') }}
            div(style='margin-bottom: 10px;' v-if="shouldShowInitialBookNowButton(service) ? showTimetradeBookNow(service) && buttonStates[service.id].displayTimetrade && service.attributes['bookable'] == true : showTimetradeBookNow(service) && service.attributes['bookable'] == true && checkBookingVendor() == 'Timetrade'")
              timetrade-button(
                :text="formatCutoverRange(category, true)"
                :query='timetradeQuery(service)'
                :activity='service'
                :loyaltyTiers='service.attributes["beauty-pass-tier"]'
                :store='store'
                :category='category'
              )
            div(style='margin-bottom: 10px;' v-if='checkBookingVendor() == "Booxi" && service.attributes["bookable"] == true')
              booxi-button(
                v-if='showBooxiBookNow()'
                :text='$t("retailStore.bookNow")'
                :apiKey='apiKey()'
              )
            div(style='margin-bottom: 10px;' v-if="shouldShowInitialBookNowButton(service) ? checkBookingVendor() == 'In House' && buttonStates[service.id].displayInhouse && service.attributes['bookable'] == true : checkBookingVendor() == 'In House' && service.attributes['bookable'] == true")
              inhouse-button(
                :text='formatCutoverRange(category, false)'
                :activity="service"
                :loyaltyTiers='service.attributes["beauty-pass-tier"]'
              )
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import { createNamespacedHelpers } from 'vuex'
import TimetradeButton from './timetrade-button.vue'
import BooxiButton from './booxi-button.vue'
import LoyaltyTiers from './loyalty-tiers.vue'
import InhouseButton from './inhouse-button.vue'
const { mapGetters } = createNamespacedHelpers('bookingService')

export default {
  name: 'CategoryServices',
  components: { TimetradeButton, LoyaltyTiers, BooxiButton, InhouseButton },
  props: [
    'category', 'services', 'store'
  ],
  data () {
    return {
      buttonStates: {}
    }
  },
  mounted () {
    this.initializeButtonStates()
     //   this.$scrollTo(this.$route.hash, 200, {
    //     offset: -110
    //   })
    // }
  },
  watch: {
    category (newCategory, oldCategory) {
      if (newCategory !== oldCategory) {
        this.initializeButtonStates()
      }
    }
  },
  computed: {
    ...mapGetters(['isBookable', 'hasVacancy', 'objectById'])
  },
  methods: {
    initializeButtonStates () {
      this.buttonStates = this.services.reduce((acc, service) => {
        acc[service.id] = {
          displayTimetrade: false,
          displayInhouse: false
        }
        return acc
      }, {})
    },
    toggleBookingOptions (serviceId) {
      this.$set(this.buttonStates, serviceId, {
        displayTimetrade: true,
        displayInhouse: true
      })
    },
    apiKey () {
      if (!this.store) {
        return { key: '' }
      }
      return { key: this.store.attributes['booxi-api-key'] }
    },
    timetradeQuery (service) {
      if (!isEmpty(service.attributes['timetrade-appointment-type-id'])) {
        if (service.attributes['timetrade-appointment-type-id'].toLowerCase() !== 'true') {
          return {
            appointmentTypeId: service.attributes['timetrade-appointment-type-id']
          }
        }
      }
    },
    showTimetradeBookNow (service) {
       return !isEmpty(service.attributes['timetrade-appointment-type-id'])
    },
    checkBookingVendor () {
      return (this.category.attributes['booking-vendor'])
    },
    showTnc () {
      if (this.checkBookingVendor() === 'In House') {
        return false
      }
      return true
    },
    showBooxiBookNow () {
      if (!this.store) {
        return true
      }
      return (this.store.attributes['booxi-api-key'] !== '')
    },
    showInHouse (service) {
      return service.attributes.bookable
    },
    checkInRange () {
      const currentDate = new Date()

      const hasCutoverFrom = this.category.attributes['cutover-from'] !== null
      const hasCutoverTill = this.category.attributes['cutover-till'] !== null

      let isWithinCutoverRange = false

      if (hasCutoverFrom && hasCutoverTill) {
        const cutoverFrom = new Date(this.category.attributes['cutover-from'])
        const cutoverTill = new Date(this.category.attributes['cutover-till'])
        isWithinCutoverRange = currentDate >= cutoverFrom && currentDate <= cutoverTill
      }
      return isWithinCutoverRange
    },
    shouldShowInitialBookNowButton (service) {
      return this.showTimetradeBookNow(service) && this.category.attributes['booking-vendor'] === 'In House' && this.checkInRange()
    },
    formatCutoverRange (category, isTimetrade = true) {
      const options = { day: '2-digit', month: 'short' }
      const cutoverFrom = category.attributes['cutover-from']
      const cutoverTill = category.attributes['cutover-till']

      if (!cutoverFrom && !cutoverTill) {
        return this.$t('retailStore.bookNow')
      }

      const cutoverTillDate = new Date(cutoverTill)

      const today = new Date()

      if (cutoverTillDate < today) {
        return this.$t('retailStore.bookNow')
      }

      const formattedFrom = new Date(cutoverFrom).toLocaleDateString('en-GB', options)
      const formattedTill = new Date(cutoverTill).toLocaleDateString('en-GB', options)

      return isTimetrade
        ? `${formattedFrom} to ${formattedTill}`
        : `${formattedTill} onwards`
     }
  }
}
</script>

<style scoped lang='scss'>
  .service-category-show {
    line-height: 20px;
  }

  .service-category-description {
    line-height: 20px;
  }

  .service-category-title {
    @include font-weight-bold;
    text-transform: uppercase;
    font-size: 13px;
    margin-bottom: 5px;
  }

  .service {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .service + .service {
    border-top: 1px solid $grey-light;
  }

  .services-image {
    width: 100%;
    margin-bottom: 20px;
  }

  .service-description {
    margin-top: 10px;
    line-height: 20px;
    margin-bottom: 10px;
  }
</style>
